import React from 'react';

export function DropdownIcon() {
  return (
    <svg
      className='-mr-1 ml-2 h-5 w-5'
      xmlns='http://www.w3.org/2000/svg'
      viewBox='0 0 20 20'
      fill='currentColor'
      aria-hidden='true'
    >
      <path
        fillRule='evenodd'
        d='M6.293 6.293a1 1 0 011.414 0L10 8.586l2.293-2.293a1 1 0 111.414 1.414l-3 3a1 1 0 01-1.414 0l-3-3a1 1 0 010-1.414z'
        clipRule='evenodd'
      />
    </svg>
  );
}
